import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import { FC, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { IRestTotalReq } from '@api/services/rKeeperApi/types';
import { getLike4Like } from '@api/thunks/reports';
import { Icons } from '@assets';
import { AppDispatch } from '@config/store';
import { useApplication } from '@/context/ApplicationContext';
import { authInfoSelect } from '@entities/auth';
import { colors } from '@styles';
import { flexMixin, textMixin } from '@styles/mixins';
import { API_DATE_FORMAT, DISPLAY_DATE_FORMAT } from '@utils/const';
import TableLike4Like from './components/reports/TableLike4Like';
const { RangePicker } = DatePicker;

const ReportRestaurantsPage: FC = () => {
    const { dateRange, setDateRange } = useApplication();
    const { shop } = useSelector(authInfoSelect);

    const from = useMemo(() => {
        return dateRange && dateRange.from
            ? dateRange.from
            : moment().add(-1, 'month').utc().format(API_DATE_FORMAT).valueOf();
    }, [dateRange]);
    const to = useMemo(
        () =>
            dateRange && dateRange.to
                ? dateRange.to
                : moment().utc().format(API_DATE_FORMAT).valueOf().valueOf(),
        [dateRange]
    );

    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        if (shop) {
            const params: IRestTotalReq = {
                from: moment.utc(from).format(API_DATE_FORMAT),
                to: moment.utc(to).format(API_DATE_FORMAT),
            };

            dispatch(getLike4Like({ shop_id: shop.id, params }));
        }
    }, [shop, dispatch, from, to]);

    const onDateChange = (dates: any, dateStrings: [string, string]) => {
        setDateRange({
            from: dayjs(dateStrings[0], DISPLAY_DATE_FORMAT)
                .format(API_DATE_FORMAT)
                .valueOf(),
            to: dayjs(dateStrings[1], DISPLAY_DATE_FORMAT)
                .format(API_DATE_FORMAT)
                .valueOf(),
        });
    };

    return (
        <Wrapper>
            <Header>
                <StyledHeadTitle>Отчеты по ресторанам</StyledHeadTitle>
                <StyledCaledarWrapper>
                    <StyledRangePicker
                        suffixIcon={
                            <img
                                src={Icons.IconMainCalendar}
                                alt="icon calendar"
                            />
                        }
                        onChange={onDateChange}
                        value={[
                            dayjs(from, API_DATE_FORMAT),
                            dayjs(to, API_DATE_FORMAT),
                        ]}
                        format={DISPLAY_DATE_FORMAT}
                    />
                </StyledCaledarWrapper>
            </Header>

            <TableLike4Like />
        </Wrapper>
    );
};

export default ReportRestaurantsPage;

const Wrapper = styled.div`
    min-width: 100%;
    height: 80%;
    background-color: ${colors.bgWhite};
    padding: 16px 29px 16px 0px;
`;

const Header = styled.div`
    width: 100%;
    ${flexMixin('row', 'space-between', 'center')};
    margin-bottom: 20px;
    flex-wrap: wrap;
    gap: 5px;
`;

const StyledRangePicker = styled(RangePicker)`
    width: 250px;
    color: ${colors.cleanWhite};
`;

const StyledHeadTitle = styled.label`
    ${textMixin({
        fontSize: '25px',
        fontWeight: 600,
    })};
    line-height: 28px;
    text-align: left;
    color: ${colors.grey};
`;

const StyledCaledarWrapper = styled.div`
    color: ${colors.cleanWhite};

    & svg {
        width: 20px;
        height: 20px;
    }
    .ant-picker {
        background-color: ${colors.primaryBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 28px;
        text-align: center;
        color: ${colors.cleanWhite};
    }

    .ant-picker .ant-picker-input,
    .ant-picker .ant-picker-range,
    .ant-picker .ant-picker-input-active .ant-picker-input-placeholder {
        display: flex;
        flex-direction: row-reverse;
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 28px;
        color: ${colors.cleanWhite};
    }

    .ant-picker .ant-picker-input .ant-picker-input-active {
        color: ${colors.cleanWhite} !important;
    }

    .ant-picker .ant-picker-input .ant-picker-input-placeholder {
        color: ${colors.cleanWhite} !important;
    }

    .ant-picker .ant-picker-input span.ant-picker-suffix,
    .ant-picker.ant-picker-range span.ant-picker-suffix {
        order: -1;
        margin-left: 0;
        margin-right: 10px;
        color: ${colors.cleanWhite};
    }

    .ant-picker.ant-picker-range.ant-picker-range-separator {
        color: ${colors.cleanWhite} !important;
    }

    .ant-picker-range-separator > span {
        color: ${colors.cleanWhite} !important;
    }

    .ant-picker-clear {
        color: ${colors.cleanWhite} !important;
    }

    .ant-picker .ant-picker-clear {
        position: absolute;
        right: 217px;
    }
`;
